import initialState from '../../data/user';
import ActionTypes from '../constants/action-types';

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_USER:
            return {
                ...state,
                user: action.payload
            };

        case ActionTypes.SET_SUBCOVER:
            return {
                ...state,
                subcovers: action.payload
            };

        case ActionTypes.SET_ONLINE_PRESENCE:
            return {
                ...state,
                presence: action.payload
            };

        case ActionTypes.ADD_ONLINE_PRESENCE:
            if (state.presence.indexOf(action.payload) < 0) {
                return {
                    ...state,
                    presence: [...state.presence, action.payload]
                };
            } else {
                return state;
            }

        case ActionTypes.REMOVE_ONLINE_PRESENCE:
            let tmp = [...state.presence];
            const index = tmp.indexOf(action.payload);

            if (index >= 0) {
                tmp.splice(index, 1);
            }

            return {
                ...state,
                presence: [...tmp]
            };

        case ActionTypes.ADD_CHUNK_ONLINE_PRESENCE:
            return {
                ...state,
                presence: [...state.presence, ...action.payload]
            };

        case ActionTypes.USER_FETCHING:
            return {
                ...state,
                isFetching: action.payload
            };

        case ActionTypes.UPDATE_USER_STORE:
            return {
                ...state,
                user: action.payload
            };

        default: return state;
    }
};

export default userReducer;
